(function ($) {
  "use strict";
  jQuery(document).ready(function ($) {

    // ========== SLIDERS ==========
    if ($('.featured-image-slider').length && $('.featured-nav-slider').length) {
      $('.featured-image-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.featured-nav-slider'
      });

      $('.featured-nav-slider').slick({
        rows: 1,
        slidesToShow: 5,
        slidesToScroll: 1,
        focusOnSelect: true,
        adaptiveHeight: true,
        dots: false,
        arrows: false,
        centerMode: false,
        vertical: true
      });
    }

    if ($('.testimonial-slider').length) {
      $('.testimonial-slider').slick({
        dots: false,
        arrows: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        autoplay: false,
        autoplaySpeed: 5000,
        fade: true,
        prevArrow: "<button class='slick-prev slick-arrow slick-disabled' aria-label='Previous' type='button' aria-disabled='true'><svg xmlns='http://www.w3.org/2000/svg' width='72' height='59' viewBox='0 0 72 59' fill='none'> <path d='M3.41668 29.1886L68.4167 29.1886' stroke='#F6F4EB' stroke-width='5.5' stroke-linecap='round' stroke-linejoin='round'/> <path d='M29.6325 55.2944L3.41581 29.1904L29.6325 3.08203' stroke='#F6F4EB' stroke-width='5.5' stroke-linecap='round' stroke-linejoin='round'/> </svg><span class='d-none'>PREV</span></button>",
        nextArrow: "<button class='slick-next slick-arrow' aria-label='Next' type='button' aria-disabled='false'><svg xmlns='http://www.w3.org/2000/svg' width='72' height='59' viewBox='0 0 72 59' fill='none'> <path d='M68.5834 29.8114L3.58337 29.8114' stroke='#F6F4EB' stroke-width='5.5' stroke-linecap='round' stroke-linejoin='round'/> <path d='M42.3676 3.70564L68.5842 29.8096L42.3676 55.918' stroke='#F6F4EB' stroke-width='5.5' stroke-linecap='round' stroke-linejoin='round'/> </svg><span class='d-none'>NEXT</span></button>",
      });
    }

    if ($('.support-slider').length) {
      $('.support-slider').slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        autoplay: false,
        autoplaySpeed: 5000,
        rows: 2,
        responsive: [
          { breakpoint: 750, settings: { slidesToShow: 2 } },
          { breakpoint: 600, settings: { slidesToShow: 2 } },
          { breakpoint: 480, settings: { slidesToShow: 1 } }
        ]
      });
    }

    if ($('.pr-review-slider').length) {
      $('.pr-review-slider').slick({
        dots: false,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: false,
        autoplay: false,
        autoplaySpeed: 5000,
        responsive: [
          { breakpoint: 991, settings: { slidesToShow: 3, arrows: false, centerMode: false } },
          { breakpoint: 800, settings: { slidesToShow: 3, arrows: false, centerMode: false } },
          { breakpoint: 750, settings: { slidesToShow: 2, centerMode: true, infinite: true } },
          { breakpoint: 600, settings: { slidesToShow: 2, centerMode: true, infinite: true } },
          { breakpoint: 480, settings: { slidesToShow: 1, centerMode: true, infinite: true } }
        ]
      });
    }

    if ($('.social-slider').length) {
      $('.social-slider').slick({
        dots: false,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        centerMode: false,
        autoplay: false,
        autoplaySpeed: 5000,
        responsive: [
          { breakpoint: 1050, settings: { slidesToShow: 4 } },
          { breakpoint: 991, settings: { slidesToShow: 4, infinite: true } },
          { breakpoint: 800, settings: { slidesToShow: 4, infinite: true } },
          { breakpoint: 750, settings: { slidesToShow: 4, infinite: true } },
          { breakpoint: 600, settings: { slidesToShow: 2, infinite: true } },
          { breakpoint: 480, settings: { slidesToShow: 1, infinite: true } }
        ]
      });
    }

    // ========== TILT EFFECT ==========
    if ($('.et-js-tilt').length) {
      $(".et-js-tilt").tilt({
        scale: 1.02,
        glare: true,
        maxGlare: 0.5,
        easing: "cubic-bezier(.03,.98,.52,.99)",
        speed: 400
      });
    }

    if ($('.et-js-tilt-alt').length) {
      $(".et-js-tilt-alt").tilt({
        scale: 1.01,
        glare: true,
        maxGlare: 0.2,
        easing: "cubic-bezier(.03,.98,.52,.99)",
        speed: 400,
        perspective: 1200,
        max: 15
      });
    }

    // ========== GENERAL FUNCTIONS ==========
    $('.search-toggle').click(function () {
      $('.header-search').toggleClass("active");
    });

    $('.close-search').click(function () {
      $('.header-search').removeClass("active");
    });

    $('.touchpoint').click(function (e) {
      e.stopPropagation();
      const parent = $(this).parent();
      if (parent.hasClass('active')) {
        parent.removeClass('active');
      } else {
        $('.touchpoint').parent().removeClass('active');
        parent.addClass('active');
      }
    });

    $(document).click(function () {
      $('.touchpoint').parent().removeClass('active');
    });

    $('.back-to-top').click(function (e) {
      e.preventDefault();
      $('html, body').animate({ scrollTop: 0 }, 600);
    });

    $('#menu-toggle').click(function () {
      $('.mobile-menu-wrapper').toggleClass("open");
      $('body').addClass("act");
      $('.header-search').removeClass("active");
    });

    $('.menu-close').click(function () {
      $('.mobile-menu-wrapper').removeClass("open");
      $('body').removeClass("act");
      $('.header-search').removeClass("active");
    });

    let lastScrollTop = 0;
    $(window).on('scroll', function () {
      let currentScroll = $(this).scrollTop();
      if (currentScroll > 0) {
        $('.stick-header').addClass('scrolled');
        if (currentScroll < lastScrollTop) {
          $('.stick-header').addClass('scrolling-up');
        } else {
          $('.stick-header').removeClass('scrolling-up');
        }
      } else {
        $('.stick-header').removeClass('scrolled scrolling-up');
      }
      lastScrollTop = currentScroll;
    });

    $('.menu-list ul li').has('ul').each(function (i) {
      $(this).addClass('has-submenu');
      const $toggle = $(this).children('a');
      const $submenu = $(this).children('ul');
      const submenuId = 'mobile-submenu-' + i;
      $submenu.attr('id', submenuId);
      $toggle.attr('aria-expanded', 'false');
      $toggle.attr('aria-controls', submenuId);
      // Toggles without an href are not keyboard-focusable by default; make them operable.
      if (!$toggle.attr('href')) {
        $toggle.attr('tabindex', '0').attr('role', 'button');
      }
      $toggle.append('<span class="submenu-toggle-icon"></span>');
    });

    function toggleMobileSubmenu($toggle) {
      const $submenu = $toggle.siblings('ul');
      const isOpen = $submenu.hasClass('active');
      $toggle.parent().siblings().find('ul').removeClass('active');
      $toggle.parent().siblings().find('a').removeClass('active').attr('aria-expanded', 'false');
      $submenu.toggleClass('active');
      $toggle.toggleClass('active');
      $toggle.attr('aria-expanded', String(!isOpen));
    }

    $('.menu-list ul li').has('ul').children('a').on('click', function (e) {
      e.preventDefault();
      toggleMobileSubmenu($(this));
    });

    $('.menu-list ul li').has('ul').children('a').on('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        toggleMobileSubmenu($(this));
      }
    });

    $(document).click(function (e) {
      if (!$(e.target).closest('ul').length) {
        $('.menu-list ul li ul').removeClass('active')
        $('.menu-list ul li a').removeClass('active').attr('aria-expanded', 'false');
      }
    });

    // Desktop mega-menu accessible disclosure (aria-expanded + keyboard support).
    // CSS reveals the panel via the [aria-expanded="true"] ~ .megamenu-wrapper rule.
    (function () {
      const items = Array.prototype.slice.call(
        document.querySelectorAll('.menu-item.has-mega-menu, .menu-item.has-dropdown')
      );
      if (!items.length) return;

      // Per-item state kept out of the element to survive re-renders.
      const state = new WeakMap();

      const panelOf = function (item) { return item.querySelector('.megamenu-wrapper, .dropdown_menu'); };
      const btnOf = function (item) { return item.querySelector('.mega-menu-toggle'); };
      // A panel counts as open if it was disclosed by keyboard/click (aria-expanded)
      // OR is currently revealed by mouse hover.
      const isOpen = function (item) {
        const btn = btnOf(item);
        if (btn && btn.getAttribute('aria-expanded') === 'true') return true;
        return item.matches(':hover');
      };
      const firstFocusable = function (panel) {
        return panel && panel.querySelector(
          'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
        );
      };

      items.forEach(function (item) {
        const btn = btnOf(item);
        if (!btn) return;
        state.set(item, { escaped: false });
        const st = state.get(item);
        const open = function () { btn.setAttribute('aria-expanded', 'true'); };
        const close = function () { btn.setAttribute('aria-expanded', 'false'); };

        // Open as soon as keyboard focus enters the item, so tabbing flows
        // link -> toggle -> panel items seamlessly. Suppressed right after Escape.
        item.addEventListener('focusin', function () { if (!st.escaped) open(); });

        // Close when focus leaves the item entirely (keyboard tab-out).
        item.addEventListener('focusout', function (e) {
          if (!item.contains(e.relatedTarget)) { close(); st.escaped = false; }
        });

        // Explicit toggle for pointer users.
        btn.addEventListener('click', function () {
          if (btn.getAttribute('aria-expanded') === 'true') { close(); }
          else { open(); }
        });
      });

      document.addEventListener('keydown', function (e) {
        // While a panel is open it takes priority: Tab moves focus INTO it even if
        // focus is currently outside the menu (e.g. it was opened by mouse hover).
        if (e.key === 'Tab' && !e.shiftKey) {
          const openItem = items.filter(isOpen)[0];
          if (!openItem) return;
          if (openItem.contains(document.activeElement)) return; // inside → natural tab
          const target = firstFocusable(panelOf(openItem));
          if (target) {
            e.preventDefault();
            const btn = btnOf(openItem);
            if (btn) btn.setAttribute('aria-expanded', 'true'); // keep open once mouse leaves
            const st = state.get(openItem);
            if (st) st.escaped = false;
            target.focus();
          }
          return;
        }

        // Escape closes the open menu and returns focus to its top-level link.
        if (e.key === 'Escape') {
          const openItem = items.filter(isOpen)[0];
          if (!openItem) return;
          const btn = btnOf(openItem);
          const st = state.get(openItem);
          if (st) st.escaped = true; // block focusin from immediately reopening
          if (btn) btn.setAttribute('aria-expanded', 'false');
          if (openItem.contains(document.activeElement)) {
            const link = openItem.querySelector('a[href]');
            if (link) link.focus();
          }
        }
      });
    })();

    $('.close-bar').click(function () {
      $('.top-bar').remove();
      $('body').removeClass("announcement-bar-active");
      localStorage.setItem('topBarClosed', 'true');
    });

    $('.mobile-filter-btn').click(function () {
      $('.collection-filters').slideToggle();
    });

  });
}(jQuery));





/*
document.addEventListener('DOMContentLoaded', function () {
  const wrappers = document.querySelectorAll('.testimonial-video-wrapper');

  wrappers.forEach(wrapper => {
    const video = wrapper.querySelector('video');
    const button = wrapper.querySelector('.play-pause-btn');
    const icon = button.querySelector('i');
    
    // Find the testimonial box within the same testimonial slide
    const testimonialBox = wrapper.closest('.ts-slide').querySelector('.testimonial-box');

    // Ensure the video starts paused
    video.pause();

    button.addEventListener('click', function () {
      if (video.paused) {
        video.play();
        icon.classList.remove('fa-play');
        icon.classList.add('fa-pause');
        video.style.objectFit = 'contain';
        button.style.height = '60px';
        button.style.width = '60px';
        icon.style.fontSize = '2rem';
        if (testimonialBox) {
          testimonialBox.style.display = 'none';
        }
      } else {
        video.pause();
        icon.classList.remove('fa-pause');
        icon.classList.add('fa-play');
        video.style.objectFit = 'cover';
         button.style.height = '80px';
        button.style.width = '80px';
        icon.style.fontSize = '3rem';
        if (testimonialBox) {
          testimonialBox.style.display = 'block';
        }

        // Reset the video
        video.currentTime = 0;
        video.load();
      }
    });

    // Hide testimonial text when video starts playing
    video.addEventListener('play', () => {
      video.style.objectFit = 'contain';
      if (testimonialBox) {
        testimonialBox.style.display = 'none';
      }
    });

    // Show testimonial text again when video ends
    video.addEventListener('ended', () => {
      video.style.objectFit = 'cover';
      if (testimonialBox) {
        testimonialBox.style.display = 'block';
      }
      icon.classList.remove('fa-pause');
      icon.classList.add('fa-play');

         // Reset button size
      button.style.width = '80px';
      button.style.height = '80px';
      icon.style.fontSize = '3rem';
    });
  });
});
*/


const _gsapSelectors = [
  '.hero_shape_1', '.hero_shape_2', '.page_banner_shape_1',
  '.support-shape-2', '.support-shape-1', '.care_shape_1', '.care_shape_2',
  '.testimonial-bg', '.pr-shape-1', '.pr-shape-2', '.pr-shape-3',
  '.cta-shape-1', '.follow-shape-1', '.tip-shape-2'
];

const animateIfExists = (selector, animation) => {
  if (typeof gsap !== 'undefined' && document.querySelector(selector)) {
    gsap.to(selector, animation);
  }
};

function _initGsapAnimations() {
  gsap.registerPlugin(ScrollTrigger);

animateIfExists(".hero_shape_1", {
    y: 110,
    scrollTrigger: {
        trigger: ".hero-area",
        start: "top 100%",
        end: "bottom 50%",
        scrub: true,
    },
});

animateIfExists(".hero_shape_2", {
    x: -110,
    scrollTrigger: {
        trigger: ".hero-area",
        start: "top 50%",
        end: "bottom 50%",
        scrub: true,
    },
});

animateIfExists(".page_banner_shape_1", {
    x: -110,
    scrollTrigger: {
        trigger: ".page-banner-area",
        start: "top 50%",
        end: "bottom 50%",
        scrub: true,
    },
});

animateIfExists(".support-shape-2", {
    x: 110,
    scrollTrigger: {
        trigger: ".support-area",
        start: "top 100%",
        end: "bottom 50%",
        scrub: true,
    },
});

animateIfExists(".support-shape-1", {
    x: -60,
    scrollTrigger: {
        trigger: ".support-area",
        start: "top 100%",
        end: "bottom 50%",
        scrub: true,
    },
});

animateIfExists(".care_shape_1", {
    x: 180,
    scrollTrigger: {
        trigger: ".care-area",
        start: "top 150%",
        end: "bottom 50%",
        scrub: true,
    },
});

animateIfExists(".care_shape_2", {
    x: -180,
    scrollTrigger: {
        trigger: ".care-area",
        start: "top 100%",
        end: "bottom -100%",
        scrub: true,
    },
});

animateIfExists(".testimonial-bg", {
    scale: 1.2,
    scrollTrigger: {
        trigger: ".testimonial-area",
        start: "top 150%",
        end: "bottom 50%",
        scrub: true,
    },
});

animateIfExists(".pr-shape-1", {
    x: -120,
    scrollTrigger: {
        trigger: ".product-review-area",
        start: "top 150%",
        end: "bottom 50%",
        scrub: true,
    },
});

animateIfExists(".pr-shape-2", {
    x: 120,
    scrollTrigger: {
        trigger: ".product-review-area",
        start: "top 50%",
        end: "bottom 50%",
        scrub: true,
    },
});

animateIfExists(".pr-shape-3", {
    x: -100,
    scrollTrigger: {
        trigger: ".product-review-area",
        start: "top 100%",
        end: "bottom -200%",
        scrub: true,
    },
});

animateIfExists(".cta-shape-1", {
    x: 130,
    scrollTrigger: {
        trigger: ".cta-area-v2",
        start: "top 50%",
        end: "bottom 100%",
        scrub: true,
    },
});

animateIfExists(".follow-shape-1", {
    x: -130,
    scrollTrigger: {
        trigger: ".tips-area",
        start: "top 100%",
        end: "bottom 100%",
        scrub: true,
    },
});

animateIfExists(".tip-shape-2", {
    x: 70,
    scrollTrigger: {
        trigger: ".tips-area .container",
        start: "top 100%",
        end: "bottom 100%",
        scrub: true,
    },
});
} // end _initGsapAnimations

if (_gsapSelectors.some(sel => document.querySelector(sel))) {
  function _loadScript(src, cb) {
    const s = document.createElement('script');
    s.src = src;
    s.defer = true;
    s.onload = cb;
    document.head.appendChild(s);
  }
  _loadScript(
    'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.11.2/gsap.min.js',
    function() {
      _loadScript(
        'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.11.2/ScrollTrigger.min.js',
        _initGsapAnimations
      );
    }
  );
}


document.addEventListener("DOMContentLoaded", () => {
  const backToTop = document.getElementById("backToTop");
  const footerArea = document.querySelector(".footer-area");

  if (!backToTop) return;

  window.addEventListener("scroll", () => {
    const scrollTop = window.scrollY;

    if (scrollTop > 150) {
      backToTop.classList.add("show");
    } else {
      backToTop.classList.remove("show");
    }

    if (footerArea) {
      const footerRect = footerArea.getBoundingClientRect();
      if (footerRect.top <= window.innerHeight) {
        backToTop.classList.remove("show");
      }
    }
  });

  backToTop.addEventListener("click", () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });
});